export const cifPw = ["301 189","<g fill-rule='nonzero' fill='none'><path fill='#4AADD6' d='M.5.75h300v187.5H.5z'/><circle fill='#FFDE00' cx='131.75' cy='94.5' r='56.25'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-pw.js
// module id = null
// module chunks = 